import { useDispatch, useSelector } from 'react-redux'

import { AppFeatures, useGetFeatureConfig } from 'hooks/useHasFeature'
import { toggleAmazonQ } from 'store/app/app.actions'
import RootState from 'store/state'

import { ReactComponent as AmazonQCloseIcon } from '../../images/amazon-q-close-icon.svg'

import ToggleAmazonQButton from './ToggleAmazonQButton'
import styles from './AmazonQ.module.scss'

const AmazonQ = () => {
    const dispatch = useDispatch()

    const getFeatureConfig = useGetFeatureConfig()
    const amazonQConfig = getFeatureConfig(AppFeatures.AMAZON_Q)

    const showAmazonQ = useSelector((state: RootState) => state.global.showAmazonQ)

    const onClick = () => dispatch(toggleAmazonQ())

    return (
        <>
            <ToggleAmazonQButton />
            <div
                className={`${styles.amazonQContainer} ${showAmazonQ ? styles.amazonQContainerVisible : ''}`}
            >
                <AmazonQCloseIcon
                    className={styles.closeAmazonQButton}
                    aria-label="Hide Amazon Q"
                    onClick={onClick}
                />

                <iframe id="amazon-q" title="Amazon Q window" src={amazonQConfig.url} />
            </div>
        </>
    )
}

export default AmazonQ
